<div class="page">
  <router-outlet></router-outlet>
  <app-loader></app-loader>
</div>